import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import GenericGuideLinksBlockData from '../../../Models/Content/GenericGuideLinksBlockData';
import GenericGuideLinks from './GenericGuideLinksBlock';

export default class GenericGuideLinksBlock extends EpiComponent<GenericGuideLinksBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ['generic-guide-links-block'];

    return (
      <div className={cssClasses.join(" ")}>
            <GenericGuideLinks iContent={this.props.data} context={this.getContext()} />
      </div>
    )
  }
}

